<!--
  LA CUENTA BANCARIA DEL COMERCIO — se embebe en «Completar mi parte» (paso Cuenta bancaria).
  Campos anchos, dos columnas (nunca un select que corte su texto). El banco es de SOLO LECTURA:
  sale del número, nunca se elige.
-->
<div class="grid max-w-3xl grid-cols-1 gap-5 sm:grid-cols-2">

  <div class="sm:col-span-2">
    <label class="kb-label" for="ctaBancNumero">
      Número de cuenta <span class="text-destructive">*</span>
    </label>
    <input id="ctaBancNumero" type="text" inputmode="numeric" class="kb-input font-mono" maxlength="20"
           placeholder="20 dígitos" [ngModel]="form.numero" (ngModelChange)="onNumero($event)"
           name="numero">
    <p class="kb-hint" *ngIf="form.numero && !numeroValido">
      Son 20 dígitos; {{ numeroLimpio.length }} de 20 hasta ahora.
    </p>
  </div>

  <div class="sm:col-span-2">
    <label class="kb-label" for="ctaBancBanco">Banco</label>
    <input id="ctaBancBanco" type="text" class="kb-input font-mono" disabled
           [value]="bancoReconocido ? (form.banco_nombre + ' · ' + form.banco) : '—'" name="banco_nombre">
    <p class="kb-hint" *ngIf="!bancosCargando && prefijo.length < 4">
      Se completa solo con los primeros 4 dígitos del número.
    </p>
    <p class="kb-texto-alerta text-xs mt-1.5" *ngIf="!bancosCargando && prefijo.length === 4 && !bancoReconocido">
      <i class="fas fa-exclamation-triangle" aria-hidden="true"></i>
      No reconocemos ningún banco con el prefijo {{ prefijo }}.
    </p>
  </div>

  <div>
    <label class="kb-label" for="ctaBancTipo">Tipo de cuenta</label>
    <div class="kb-select-envoltorio">
      <select id="ctaBancTipo" class="kb-select" [ngModel]="form.tipo"
              (ngModelChange)="form.tipo = $event; emitir()" name="tipo">
        <option value="CORRIENTE">Corriente</option>
        <option value="AHORRO">Ahorro</option>
      </select>
      <i class="fas fa-chevron-down kb-select-flecha" aria-hidden="true"></i>
    </div>
  </div>

  <div>
    <label class="kb-label" for="ctaBancMoneda">Moneda</label>
    <div class="kb-select-envoltorio">
      <select id="ctaBancMoneda" class="kb-select" [ngModel]="form.moneda"
              (ngModelChange)="form.moneda = $event; emitir()" name="moneda">
        <option value="VES">Bolívares</option>
        <option value="USD">Dólares</option>
      </select>
      <i class="fas fa-chevron-down kb-select-flecha" aria-hidden="true"></i>
    </div>
  </div>

  <div>
    <label class="kb-label" for="ctaBancTitular">Titular</label>
    <input id="ctaBancTitular" type="text" class="kb-input" [ngModel]="form.titular"
           (ngModelChange)="form.titular = $event; emitir()" name="titular">
  </div>

  <div>
    <label class="kb-label" for="ctaBancRif">RIF del titular</label>
    <app-rif-input inputId="ctaBancRif" [valor]="form.rif_titular"
                   (valorChange)="form.rif_titular = $event; emitir()"></app-rif-input>
  </div>

  <p class="kb-hint sm:col-span-2 -mt-3" *ngIf="!hayAviso && (razonSocial || rif)">
    El titular y su RIF vienen de los datos del comercio. Cámbialos si la cuenta es de otro titular.
  </p>

  <!-- Avisa, no frena: la cuenta puede ser de otro titular (un tercero que le cobra al comercio). -->
  <div class="sm:col-span-2" *ngIf="hayAviso">
    <p class="kb-texto-alerta text-sm">
      <i class="fas fa-exclamation-triangle" aria-hidden="true"></i>
      El titular o su RIF no coinciden con la razón social o el RIF del comercio. Puede ser correcto
      (una cuenta de un tercero); si no, revísalo antes de continuar.
    </p>
  </div>

</div>
